import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { PersonProps } from 'Components/common/components/PeopleCardLarge';
import { usePrevious } from 'Utils/hooks/usePrevious';
import classNames from 'classnames';
import { dragInteractionStyle } from 'Utils/performance/renderOptimizations';

type Props = {
  children: JSX.Element
  isDrag: (d: boolean) => void
  highlighted?: boolean
};

const defaultProps = {
  highlighted: false,
};

const DragWrapper = function DragWrapper({ children, isDrag, highlighted }: Props) {
  const { isPersonPage, ...restProps } = children.props;

  const [{
    isDragging, offset,
  }, drag, preview] = useDrag(
    () => ({
      type: 'PEOPLE',
      item: { ...restProps } as PersonProps,
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
        offset: monitor.getDifferenceFromInitialOffset(),
      })
    }),
    [children.props],
  );

  const prevIsDragging = usePrevious(isDragging);

  useEffect(() => {
    if (prevIsDragging && !isDragging) isDrag(isDragging);
  }, [isDragging, isDrag, prevIsDragging]);

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  useEffect(() => {
    if (offset && offset.x && offset.y) {
      if (Math.abs(offset.x) > 70 || Math.abs(offset.y) > 70) { isDrag(true); }
    }
  }, [isDrag, offset]);

  return (
    <div
      ref={drag}
      style={dragInteractionStyle}
      className={classNames(
        {
          highlightedComponent: highlighted,
          downloadProfileBtn: highlighted,
          grabber: !isDragging,
          backActive: isDragging,
        },
      )}
    >
      {children || null}
    </div>
  );
};

export default React.memo(DragWrapper);
DragWrapper.defaultProps = defaultProps;